import React from 'react';
import {Card,
        CardMedia,
        makeStyles,
        Typography,
        Button,
        Grid,
} from '@material-ui/core/';
import lineImg from '../Images/lines3.png';

const useStyles = makeStyles({
    root: {
        height: '60vh',
    },
    btnStyle : {
        height: 60,
        width: 300,
    },
    pos: {
        marginBottom: 20,
    }
})

function ContactUs() {
    const classes = useStyles();

    return(
        <Card>
            <CardMedia className={classes.root} image={lineImg} >
                <Grid container direction='column' justify='center' alignItems='center' style={{ height: '100%' }}>

                    <Typography className={classes.pos} color='textPrimary' variant='h3' align='center' >
                        Těšíme se na vaši návštěvu
                    </Typography>

                    <Button href='/contact' className={classes.btnStyle} size='large' variant='contained' color='primary'>
                        Kontaktujte nás
                    </Button>

                </Grid>
            </CardMedia>
        </Card>
    )
}

export default ContactUs;